import { FieldSet } from "client/lib/apt-merchant";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { Industry, IndustryLabel, MerchantField } from "../../types";

const industryLabelToValue: Record<IndustryLabel, Industry> = {
  "Art (non-collectible)": "Art (non-collectible)",
  Adult: "Adult",
  Airlines: "Airlines",
  Apparel: "Apparel",
  "Automotive (non-services no vehicles)": "Automotive",
  "Beauty / Cosmetics Products (NOT salons)": "Beauty / Cosmetic Products",
  "Books (non digital)": "Books",
  "Car Hire & Rentals": "Car Hire & Rentals",
  "Charitable Donations": "Charitable Donations",
  "Department Stores / Big Box Retail": "Department Stores",
  "Home Appliances": "Domestic Appliances",
  "Education (Services and Courses)": "Education Services",
  Electronics: "Electronics",
  Eyewear: "Eyewear",
  "Fitness Equipment (NOT clothing)": "Fitness",
  "Food - Quick Service / Fast Food": "Food - Quick Service / Fast Food",
  "Food & Beverage (no alcohol, non-perishable)":
    "Food & Beverage (no alcohol, non-perishable)",
  "Food Delivery, Meal Kits, and Restaurants": "Food Delivery",
  Footwear: "Footwear",
  Furniture: "Furniture",
  "Food - Perishable (incl. grocery)": "Groceries",
  "Beauty Salon & Hair": "Hair & Beauty Salon",
  "Hardware & Tools": "Hardware",
  "Health Services (dentistry etc.)": "Health",
  "Homewares & Garden (non-furniture)": "Home & Garden (non-furniture)",
  "Hotels & Accommodation": "Hotels & Accommodation",
  Kids: "Kids",
  Jewelry: "Jewelry",
  Jewellery: "Jewellery",
  "Office Supplies": "Office",
  "Other (Only select if your industry is not listed)": "Other",
  "Sporting & Outdoor Goods (no weapons)": "Outdoor",
  "Online Travel Agents": "Online Travel Agents",
  "Perfumes & Fragrances": "Perfumes & Fragrances",
  "Pets (no live animals)": "Pets",
  "Pharmaceuticals (Prescriptions)": "Pharmaceuticals",
  "Services (non financial, non invasive)": "Services",
  Ticketing: "Ticketing",
  "Hobby Stores & Toys": "Toys",
  Utilities: "Utilities",
  "Vitamins / Supplements (non-prescription)": "Vitamins/Supplements",
  "Hair Extensions or Wigs": "Hair Extensions",
};

export const industryValueToLabel: Record<Industry, IndustryLabel> = {
  "Art (non-collectible)": "Art (non-collectible)",
  Adult: "Adult",
  Airlines: "Airlines",
  Apparel: "Apparel",
  Automotive: "Automotive (non-services no vehicles)",
  "Beauty / Cosmetic Products": "Beauty / Cosmetics Products (NOT salons)",
  Books: "Books (non digital)",
  "Car Hire & Rentals": "Car Hire & Rentals",
  "Charitable Donations": "Charitable Donations",
  "Department Stores": "Department Stores / Big Box Retail",
  "Domestic Appliances": "Home Appliances",
  "Education Services": "Education (Services and Courses)",
  Electronics: "Electronics",
  Eyewear: "Eyewear",
  Fitness: "Fitness Equipment (NOT clothing)",
  "Food - Quick Service / Fast Food": "Food - Quick Service / Fast Food",
  "Food & Beverage (no alcohol, non-perishable)":
    "Food & Beverage (no alcohol, non-perishable)",
  "Food Delivery": "Food Delivery, Meal Kits, and Restaurants",
  Footwear: "Footwear",
  Furniture: "Furniture",
  Groceries: "Food - Perishable (incl. grocery)",
  "Hair & Beauty Salon": "Beauty Salon & Hair",
  "Hair Extensions": "Hair Extensions or Wigs",
  Hardware: "Hardware & Tools",
  Health: "Health Services (dentistry etc.)",
  "Home & Garden (non-furniture)": "Homewares & Garden (non-furniture)",
  "Hotels & Accommodation": "Hotels & Accommodation",
  Jewelry: "Jewelry",
  Jewellery: "Jewellery",
  Kids: "Kids",
  Office: "Office Supplies",
  Other: "Other (Only select if your industry is not listed)",
  Outdoor: "Sporting & Outdoor Goods (no weapons)",
  "Online Travel Agents": "Online Travel Agents",
  "Perfumes & Fragrances": "Perfumes & Fragrances",
  Pets: "Pets (no live animals)",
  Pharmaceuticals: "Pharmaceuticals (Prescriptions)",
  Services: "Services (non financial, non invasive)",
  Ticketing: "Ticketing",
  Toys: "Hobby Stores & Toys",
  Utilities: "Utilities",
  "Vitamins/Supplements": "Vitamins / Supplements (non-prescription)",
};

export const sharedIndustryList: {
  label: IndustryLabel;
  value: Industry;
}[] = [
  { label: "Adult", value: "Adult" },
  { label: "Airlines", value: "Airlines" },
  { label: "Apparel", value: "Apparel" },
  { label: "Art (non-collectible)", value: "Art (non-collectible)" },
  { label: "Automotive (non-services no vehicles)", value: "Automotive" },
  {
    label: "Beauty / Cosmetics Products (NOT salons)",
    value: "Beauty / Cosmetic Products",
  },
  { label: "Beauty Salon & Hair", value: "Hair & Beauty Salon" },
  { label: "Books (non digital)", value: "Books" },
  { label: "Car Hire & Rentals", value: "Car Hire & Rentals" },
  { label: "Charitable Donations", value: "Charitable Donations" },
  {
    label: "Department Stores / Big Box Retail",
    value: "Department Stores",
  },
  { label: "Education (Services and Courses)", value: "Education Services" },
  { label: "Electronics", value: "Electronics" },
  { label: "Eyewear", value: "Eyewear" },
  {
    label: "Fitness Equipment (NOT clothing)",
    value: "Fitness",
  },
  {
    label: "Food - Perishable (incl. grocery)",
    value: "Groceries",
  },
  {
    label: "Food - Quick Service / Fast Food",
    value: "Food - Quick Service / Fast Food",
  },
  {
    label: "Food & Beverage (no alcohol, non-perishable)",
    value: "Food & Beverage (no alcohol, non-perishable)",
  },
  {
    label: "Food Delivery, Meal Kits, and Restaurants",
    value: "Food Delivery",
  },
  { label: "Footwear", value: "Footwear" },
  { label: "Furniture", value: "Furniture" },
  { label: "Hair Extensions or Wigs", value: "Hair Extensions" },
  { label: "Hardware & Tools", value: "Hardware" },
  {
    label: "Health Services (dentistry etc.)",
    value: "Health",
  },
  { label: "Hobby Stores & Toys", value: "Toys" },
  { label: "Home Appliances", value: "Domestic Appliances" },
  {
    label: "Homewares & Garden (non-furniture)",
    value: "Home & Garden (non-furniture)",
  },
  { label: "Hotels & Accommodation", value: "Hotels & Accommodation" },
  { label: "Jewelry", value: "Jewelry" },
  { label: "Kids", value: "Kids" },
  { label: "Office Supplies", value: "Office" },
  { label: "Online Travel Agents", value: "Online Travel Agents" },
  {
    label: "Other (Only select if your industry is not listed)",
    value: "Other",
  },
  { label: "Perfumes & Fragrances", value: "Perfumes & Fragrances" },
  { label: "Pets (no live animals)", value: "Pets" },
  {
    label: "Pharmaceuticals (Prescriptions)",
    value: "Pharmaceuticals",
  },
  {
    label: "Services (non financial, non invasive)",
    value: "Services",
  },
  {
    label: "Sporting & Outdoor Goods (no weapons)",
    value: "Outdoor",
  },
  { label: "Ticketing", value: "Ticketing" },
  { label: "Utilities", value: "Utilities" },
  {
    label: "Vitamins / Supplements (non-prescription)",
    value: "Vitamins/Supplements",
  },
];

export class IndustryField extends Field<IndustryLabel> {
  constructor(
    model: Merchant,
    fieldSet: FieldSet<any>,
    opts: Partial<MerchantField<IndustryLabel>> = {}
  ) {
    super(
      model,
      {
        dataType: "string",
        testValue: "Adult",
        propertyName: "industry",
        applicable: true,
        uiFieldType: "Select",
        pickList: sharedIndustryList as any,
        ...opts,
      },
      fieldSet
    );
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  get value(): any {
    // when getting the values ie. when we post to backend, we use the SF equivalent strings
    if (typeof this._value === "undefined") return;
    return industryLabelToValue[this._value as IndustryLabel];
  }

  set value(v: any) {
    // do the opposite when setting value
    if (typeof v === "undefined") return;
    const res = industryValueToLabel[v as Industry];
    this._value = res;
  }
}
